import { AdvertisementArea, RewardType } from '../../SDK/Advertisement';
import { IDataSet } from '../Track';

export enum AdContexts {
    LOSS_AVERSION = 'LOSS_AVERSION',
    WIN_SEQUENCE = 'WIN_SEQUENCE',
    MAP_WHEEL = 'MAP_WHEEL',
}

export enum AdType {
    INTERSTITIAL = 'INTERSTITIAL',
    REWARDED = 'REWARDED',
}

export enum AdGameArea {
    MAP = 'MAP',
    BOTTOM_SCREEN = 'BOTTOM_SCREEN',
    SIDE_SCREEN = 'SIDE_SCREEN',
    LEVEL = 'LEVEL',
    FAIL_FLOW = 'FAIL_FLOW',
}

export class AdDataSet implements IDataSet {
    public adType: AdType = undefined;
    public placementID: string = undefined;
    // public adName: string = undefined;
    public adAdvertisementArea: AdvertisementArea = undefined;
    public adGameArea: AdGameArea = undefined;
    public adRewardType: RewardType = undefined;
    public adLevelNum: number = 0;
    public adID: string = undefined;
    public adLevelType: string = undefined;
    public adSuccess: number = 0;
    public adCoinsReceived: number = 0;
    public adExtraCardsReceived: number = 0;
    // public error: string = undefined;
    // public adLevelID: string = 0;
}
